<template>
    <div class="row">
         <div class="col-12 mb-1">
            <label class="form-label">Yük Ana Grubu</label>
            <v-validator :errors="errors" parameter="ShipableProductMainGroupId" :watch="shipableProduct">
                <v-select-list v-model="shipableProduct" label="Name" placeholder="Yük Ana Grubu" :options="shipableProducts"/>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Yük Alt Grubu</label>
            <v-validator :errors="errors" parameter="Name" :watch="value.Name">
                <input type="text" class="form-control" placeholder="Yük Alt Grubu" v-model="value.Name"/>
            </v-validator>
        </div>
    </div>
</template>

<script>
import ShipableProductApi from '@/api/shipable-product'
export default {
    props:{
        value:Object,
        errors:Object
    },
    components:{
    },
    mounted(){
        this.getShipableProductMainGroup();
    },
    data(){
        return{
            shipableProducts:[],
        }
    },
    methods:{
        getShipableProductMainGroup(){
            ShipableProductApi.MainGroup.List()
            .then(res=>{
                this.shipableProducts = res.data.Data
            })
        },
    },
    computed:{
        shipableProduct:{
            get:function(){
                return this.shipableProducts.find(b=>b.Id==this.value.ShipableProductMainGroupId)
            },
            set:function(value){
                this.value.ShipableProductMainGroupId = value?.Id || this.value.ShipableProductMainGroupId
            }
        }
    }
}
</script>

<style lang="scss">
</style>